import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Validators } from '@angular/forms';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-campaign-in-kind-settings',
  templateUrl: './campaign-in-kind-settings.component.html',
  styleUrls: ['./campaign-in-kind-settings.component.scss']
})
export class CampaignInKindSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaignTypeData: any = null;

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public campaignService: CampaignService
  ) {}

  ngOnInit(): void {
    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData, 'postActivityFormUrlRequired', [
      { name: 'postActivityFormUrl', defaultValue: "", validators: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)] }
    ], this.takeUntilSubject);
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
